import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Box,
  Checkbox,
  Container,
  Divider,
  FormControlLabel,
  Stack,
} from "@mui/material";


import { InputYear } from "../../Components/Inputs/Input_Year.jsx";
import { errorClear, errorSet, errorSetPlus } from "../../Components/Inputs/Input_Fns.jsx";

import { set } from "lodash";

import ValueInflatable from "../../App/ValueInflatable.jsx";
import {
  getOptions,
  putOptions,
  AccountUrl_get,
  AccountUrl_put,
  ftchPlus,
  CleanAvail,
} from "../../App/Account_urls.jsx";

import {
  CollapseAdd,
  CollapseAddLabel,
  CollapseDelete,
  CollapseDeleteLabel,
  CollapseStateLabel,
} from "../../App/CollapseButtons.jsx";

import { AddDialog } from "../../Components/AddDialog.jsx";
import {
  InputPercentage,
} from "../../Components/Inputs/Input_Percentage.jsx";
import { Input_label, InputName } from "../../Components/Inputs/Input_Name.jsx";
import { InputSelect1, InputSelectN } from "../../Components/Inputs/Select.jsx";
import { InputCheck } from "../../Components/Inputs/Input_Check.jsx";
import { Arrayify } from "../../Functions/utils.jsx";

var init_v = {
  Id: 0,
  Actual: false,
  Additional: false,
  UpToAge: 0,
  SpousePercentage: 0,
  Value: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Never",
    Rate: 0,
  },
};
var ret_v = {
  Id: 0,
  Type: "Interest",
  Rate: 0,
};

var ann = {
  Id: 0,
  Year: new Date().getFullYear() - 1,
  Comment: "",
  BirthYear: 1970,
  Init: [init_v],
  Return: [ret_v],
  Payment: {
    Type: "Value Only",
    Value: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Never",
      Rate: 0,
    },
    Additional: false,
    SpousePercentage: 0,
  },
};

var ds = {
  Name: "",
  BirthYear: 1970,
  Priority: 0,
  Attributes: "",
  Annual: [ann],
};

const Payment = ({ avail, form, onChange, onError }) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    onChange(nf);
  };


  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };
  const onChangeMe = (value, uptoage, SpousePercentage) => {
    let nf = {
      ...form,
      UpToAge: uptoage,
      SpousePercentage: SpousePercentage,
      Value: value,
    };
    onChange(nf);
  };
  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }


  return (
    <Stack direction="row" spacing={2}>
      <InputSelect1
        label="Payment Type"
        value={form.Type}
        onChange={onChange_t}
        name="Type"
        avail={avail.LoanPaymentTypes}
      />

      {/* <Input_Money
        label="Payment"
        money={form.Value}
        // additional loan value (prop tax in BC might be -ve with no payment)
        //disabled={form.Type === "No Payment+"}
        min={-1000000}
        max={1000000}
        onChange={onChange_t}
        onError={(e) => myError("payment", null, e)}

      /> */}
      <ValueInflatable
        form={form.Value}
        doUpTo={false}
        label="Payment"
        dosp={true}
        doInfR={false}
        doThr={false}
        SpousePercentage={form.SpousePercentage}
        onChange={onChangeMe}
        avail={avail}
        valueMin={-10000000}
        showInf={false}
        onError={(e) => myError("payment", null, e)}

      />

      {/* <Input_Percentage_Spouse
        percent={form.SpousePercentage}
        disabled={form.Type === "No Payment+"}
        onChange={onChange_t}
        onError={(e) => myError("payment", null, e)}

      /> */}
      <Box>
        <InputCheck
          sx={{ mt: -2 }}
          value={form.Additional}
          label="Additional Payment"
          name="Additional"
          onChange={onChange_any}
        />
      </Box>
    </Stack>
  );
};

const RateOfReturn = ({ avail, form, onChange, onError }) => {
  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    //setForm(nf);
    console.log(nf);
    onChange(nf);
  };


  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  return (
    <Stack direction="row" spacing={2}>
      <InputPercentage
        label={"Interest Rate"}
        name="Rate"
        width={100}
        percent={form.Rate}
        onChange={onChange_t}
        onError={onError}

      />
    </Stack>
  );
};

const ValueInit = ({ avail, form, onChange, dosp, onError }) => {
  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    //setForm(nf);
    console.log(nf);
    onChange(nf);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };
  const onChange_nv = (e) => {
    onChange_any(e.target.name, e.target.value);
    form.Value.Value = e.target.value;
    onChange(form);
  };

  const onChangeMe = (value, uptoage, SpousePercentage) => {
    let nf = {
      ...form,
      UpToAge: uptoage,
      SpousePercentage: SpousePercentage,
      Value: value,
    };
    onChange(nf);
  };
  return (
    <Stack direction="row" spacing={2}>
      <Stack>
        <FormControlLabel
          sx={{ mt: -4 }}
          control={
            <Checkbox
              size="small"
              checked={form.Actual}
              onChange={(e) => {
                onChange_any("Actual", e.target.checked);
              }}
            />
          }
          label="Actual"
        />
        <FormControlLabel
          sx={{ mt: -2 }}
          control={
            <Checkbox
              size="small"
              checked={form.Additional}
              onChange={(e) => {
                onChange_any("Additional", e.target.checked);
              }}
            />
          }
          label="Additional"
        />
      </Stack>
      {/* this can be inflatable if its a future loan, we inflate up to when we start payments
       */}
      <ValueInflatable
        key={"VI-V+ " - " + form.Id"}
        form={form.Value}
        doUpTo={false}
        label="Loan"
        dosp={dosp}
        doInfR={false}
        doThr={false}
        SpousePercentage={form.SpousePercentage}
        onChange={onChangeMe}
        avail={avail}
        showInf={false}
        onError={onError}

      />
      {/* <Input_Money
        label="Loan"
        name="Value.Value"
        money={form.Value.Value}
        onChange={onChange_nv}
      /> */}
    </Stack>
  );
};

const ValueYear = ({ avail, form, onChange, dosp, onError }) => {
  const [errors, setErrors] = useState({})
  const [addNotes, setAddNotes] = useState(false);

  const onChange_any = (n, v) => {
    // console.log("VY:change");
    // console.log(form);
    // console.log(n);
    // console.log(v);
    let nf = {
      ...form,
      [n]: v,
    };
    // console.log(nf);
    onChange(nf);
  };


  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChangeMe = (e, i) => {
    // console.log("VY:onchangeMe");
    // console.log(e);
    // console.log(i);
    let json = form;
    json.Init[i] = e;
    onChange_any("Init", json.Init);
  };

  const onAdd = () => {
    let n_init = structuredClone(init_v);
    let json = [];
    if (form.Init) {
      json = form.Init.slice();
      n_init.Id = Math.max(...form.Init.map((o) => o.Id), 0) + 1;
    }
    // console.log(n_init);
    json.push(n_init);
    onChange_any("Init", json);
  };
  const onDelete = (e, Id) => {
    let json = form.Init.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any("Init", json);
  };
  const onChangeRMe = (e, i) => {
    let json = form;
    json.Return[i] = e;
    onChange_any("Return", json.Return);
  };

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  useEffect(() => {
    if (form.Comment && form.Comment !== "") {
      setAddNotes(true)
    }

  }, [form])

  return (
    <Container maxWidth="true">
      <Box sx={{ my: 2, pt: 3, pb: 1, pl: 2, border: "1px solid grey" }}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
            <InputYear
              year={form.Year}
              birthYear={form.BirthYear}
              onChange={onChange_t}
              onError={(e) => myError("year", null, e)}
            />
            <Stack spacing={2}>
              <Stack spacing={2} direction="row">

                <CollapseAddLabel
                  label="Value"
                  onClick={onAdd}
                />
                <Stack spacing={2}>

                  {Arrayify(form.Init).map((v, i) => (
                    <Stack key={"st-" + i} direction="row" spacing={2}>
                      <ValueInit
                        avail={avail}
                        form={v}
                        dosp={dosp}
                        onChange={(e) => onChangeMe(e, i)}
                        onError={(e) => myError("valueI", i, e)}

                      />
                      <CollapseDeleteLabel
                        onClick={(e) => onDelete(e, v.Id)}
                      />
                    </Stack>
                  ))}
                </Stack>

                <Stack spacing={2}>
                  {Arrayify(form.Return).map((d, i) => (
                    <RateOfReturn
                      key={"return-i-" + d.Id}
                      avail={avail}
                      form={d}
                      onChange={(e) => onChangeRMe(e, i)}
                      onError={(e) => myError("ror", i, e)}

                    />
                  ))}
                </Stack>
                <Divider orientation="vertical" flexItem />
                <Payment
                  avail={avail}
                  form={form.Payment}
                  onChange={(value) => onChange_any("Payment", value)}
                  onError={(e) => myError("payment", null, e)}

                />
                <CollapseStateLabel
                  add={addNotes}
                  label="Notes"
                  onClick={setAddNotes}
                />
              </Stack>
              {addNotes && (
                <Stack direction="row" spacing={2} sx={{ mx: -4 }}>
                  <Input_label
                    label="Notes"
                    name="Comment"
                    value={form.Comment}
                    maxLength={800}
                    width={800}
                    required={false}
                    onChange={onChange_t}
                    errors={errors}
                    onError={(name, e) => myError(name, null, e)}
                  />

                </Stack>
              )}

            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Container >
  );
};

const AddLiabilityAccount = ({
  show,
  close,
  client_p,
  clientJson,
  c_callback,
  account,
  account_uuid,
  accountType,
  add,
  dosp = false,
}) => {
  const data = useRef();
  const [form, setForm] = useState();
  const [dataset, setDataset] = useState();
  const [client, setClient] = useState(client_p);
  const [clients, setClients] = useState([client_p]);
  const [added, setAdded] = useState([false, false]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [deleted, setDeleted] = useState(false)


  const getInputData = (client_) => {
    let url = AccountUrl_get(clientJson, "account", account, account_uuid, add, accountType);

    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setAdded([false, false]);
          data.current = json;
          setForm(json);
          setClients(json.Clients);
          Update(client_);
          console.log(data.current);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)

      });
  };

  const putRequest = async () => {
    let url = AccountUrl_put(
      clientJson,
      "account",
      form.DataSet[client].Name,
      form.DataSet[client].AccountUuid,
      form.DataSet[client].NameOrig,
      add
    );
    var req = putOptions;
    let post = CleanAvail(form);
    req.body = JSON.stringify(post);

    ftchPlus(url, req)
      .then((response) => {
        console.log("update completed");
        myClose();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)

      });
  };

  const onSubmit = () => {
    console.log("on submit");
    console.log(form);
    putRequest();
  };

  const myClose = (e) => {
    data.current = null;
    setDataset(null);
    close(accountType);
  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      setDeleted(false)

      getInputData(client_p);
    }
  }, [show]);

  useEffect(() => {
    let cl = client === clients[0] ? 0 : 1;
    if (add && dataset && !added[cl]) {
      onAdd();
      let x = added;
      x[cl] = true;
      setAdded(x);
    }
  }, [add, dataset]);

  const Update = (cl) => {
    setClient(cl);
    setDataset(data.current.DataSet[cl]);
  };

  const onChange_any = (subpath, any) => {
    // console.log("any_change: ");
    // console.log(any);
    let path = "DataSet[" + client + "]";
    if (subpath !== "") {
      path += "." + subpath;
    }

    // console.log("Path: " + path);
    let nf = form;
    nf = set(nf, path, any);
    setForm(nf);
    nf = {
      ...nf,
    };
    setForm(nf);

    Update(client);
    // console.log(nf);
  };

  const onChangeMe = (e, i) => {
    // console.log("SA");
    // console.log(e);
    // console.log(i);

    if (e.Init.length !== 0) {
      let path = "Annual[" + i + "]";
      onChange_any(path, e);
    } else {
      // console.log(dataset);
      let path = "Annual[" + i + "]";
      onChange_any(path, e);
      let json = data.current.DataSet[client].Annual.slice();
      json = json.filter((o) => o.Init.length !== 0);
      // console.log(json);
      onChange_any("Annual", json);
    }
  };

  const btnClientChanged = (cl) => {
    Update(cl);
  };



  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onAdd = () => {
    let n_ann = structuredClone(ann);
    let json = [];
    if (dataset.Annual) {
      json = dataset.Annual.slice();
      n_ann.Id = Math.max(...dataset.Annual.map((o) => o.Id), 0) + 1;
      n_ann.Year = Math.max(...dataset.Annual.map((o) => o.Year), 0) + 1;
    }
    if (n_ann.Year === 1) {
      n_ann.Year = new Date().getFullYear();
    }
    n_ann.BirthYear = dataset.BirthYear;
    json.push(n_ann);
    console.log(json);
    onChange_any("Annual", json);
  };
  const onDelete = (e, Id) => {
    let json = dataset.Annual.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any("Annual", json);
    setDeleted(true)
  };

  const onChange_list = (e) => {
    const value = e.target.value;
    const values = typeof value === "string" ? value.split(",") : value;
    console.log(values);
    onChange_any(e.target.name, values);
  };

  const myError = (obj, i, err) => {
    errorSet(errors, setErrors, obj, i, err)
  }

  return (
    <>
      <AddDialog
        clientJson={clientJson}
        c_callback={c_callback}
        onClose={myClose}
        open={show}
        clients={clients}
        client={client}
        label={accountType}
        accountType={accountType}
        onClientChange={btnClientChanged}
        onSubmit={onSubmit}
        errors={errors}
        errmsg={errmsg}
        deleted={deleted}

      >
        {data !== null && dataset !== undefined && dataset !== null && (

          <Stack sx={{ mx: 4 }}>
            <Stack direction="row" spacing={2}>
              <InputName
                key="ds.name"
                value={dataset.Name}
                accountName={true}
                onChange={onChange_t}
                onError={(e) => myError("name", 0, e)}
              />
              <InputSelectN
                label="Attributes"
                name="Attributes"
                value={dataset.Attributes}
                onChange={onChange_list}
                minWidth={200}
                errors={errors}
                avail={dataset.Avail.LiabilityAttributes}
              />
            </Stack>

            <Stack direction="row" spacing={2}>
              <Stack sx={{ py: 4 }}>
                <CollapseAdd onClick={onAdd}
                  tooltip="Add a new year"
                />
              </Stack>
              <Stack spacing={-3}>
                {Arrayify(dataset.Annual).map((d, i) => (
                  <Stack key={"sd-" + d.Id} direction="row" spacing={2}>
                    <ValueYear
                      avail={dataset.Avail}
                      form={d}
                      dosp={dosp}
                      onChange={(e) => onChangeMe(e, i)}
                      onError={(e) => myError("value", i, e)}

                    />
                    <Stack sx={{ py: 4 }}>
                      <CollapseDelete
                        onClick={(e) => onDelete(e, d.Id)}
                      />
                    </Stack>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </Stack>
        )}

      </AddDialog>
    </>
  );
};

export default AddLiabilityAccount;
